// extracted by mini-css-extract-plugin
export default {"root":"nIFTtEzp","root__mobile":"Acn904fW","wrapper":"zM8pbgQK","logo":"oZTWeHvQ","root__desktop":"AkvA1c6r"};